import React from "react";

import {
    emptyState,
    emptyStateImage,
    emptyStateBody,
    emptyStateTitle,
    emptyStateText,
} from "./account-empty-state.module.scss";

interface IAccountEmptyStateProps {
    image: string;
    title: string;
    children: React.ReactNode;
}

export default function AccountEmptyState({
    image,
    title,
    children,
}: IAccountEmptyStateProps) {
    return (
        <div className={emptyState}>
            <img
                className={emptyStateImage}
                src={image}
                alt=""
                aria-hidden="true"
            />
            <div className={emptyStateBody}>
                <h2 className={emptyStateTitle}>{title}</h2>
                <p className={emptyStateText}>{children}</p>
            </div>
        </div>
    );
}
